import { ArrowRightIcon, PlusCircledIcon } from '@radix-ui/react-icons';
import { AccessibleIcon, Box, Flex, Grid, mdxComponents, Text } from '@workos-inc/design-system';
import { Diagram } from './diagram';

// Introducing lint rule banning type assertions
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const MdxImage = mdxComponents.Image as React.FC<React.PropsWithChildren>;
const Directory = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="Directory" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="A diagram showing that directory providers relay the directory data to WorkOS, then WorkOS normalizes the data, and then your app interfaces with WorkOS, receiving and pushing updates" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 784 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="320" width="784" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Directory providers</Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <svg fill="none" viewBox="0 0 208 246" width="100%" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <g fill="var(--gray-a8)" data-sentry-element="g" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <path d="M80.79 44.57c-2 0-3.42-1.57-3.42-3.62 0-2.06 1.41-3.63 3.42-3.63 2 0 3.38 1.57 3.38 3.63 0 2.05-1.4 3.62-3.38 3.62Zm-.32 2.16c1.61 0 2.99-.63 3.86-1.96.16 1.29 1.09 1.75 2.26 1.75h.93V44.5h-.4c-.66 0-.83-.32-.83-1.08v-8.04h-2.14v1.66a4.26 4.26 0 0 0-3.68-1.86c-2.82 0-5.4 2.36-5.4 5.78 0 3.41 2.59 5.77 5.4 5.77Zm-11.05-2.8c0 1.84 1.13 2.6 2.49 2.6h2.61v-2.04h-1.9c-.8 0-.96-.3-.96-1.08v-6h2.86v-2.04h-2.86v-3.74h-2.24v12.3Zm-10.21 2.6h2.24v-4.79h.75l3.82 4.78h2.84l-4.88-6.06 3.74-5.09H65.2l-3.06 4.3h-.7v-8.04h-2.23v14.9Zm-7.29-11.36a5.62 5.62 0 0 0-5.72 5.78c0 3.41 2.6 5.77 5.72 5.77a5.63 5.63 0 0 0 5.73-5.77c0-3.42-2.6-5.78-5.73-5.78Zm0 9.4c-2 0-3.42-1.57-3.42-3.62 0-2.06 1.42-3.63 3.42-3.63 2.01 0 3.42 1.57 3.42 3.63 0 2.05-1.41 3.62-3.42 3.62Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path clipRule="evenodd" d="m28.71 29.17-.49 6a6.11 6.11 0 0 0-1.56.03l-.28-2.91c0-.1.07-.17.16-.17h.5l-.24-2.94c-.01-.1.06-.17.15-.17h1.6c.1 0 .17.08.16.17Zm-4.07.3c-.02-.09-.11-.14-.2-.1l-1.51.54a.15.15 0 0 0-.09.21l1.23 2.69-.46.17a.15.15 0 0 0-.09.21l1.26 2.64c.45-.25.94-.44 1.46-.56l-1.59-5.8Zm-3.7 1.67 3.47 4.9a5.7 5.7 0 0 0-1.18 1.03l-2.08-2.05a.16.16 0 0 1 0-.23l.38-.32-2.07-2.1a.15.15 0 0 1 .01-.23l1.23-1.03a.15.15 0 0 1 .23.03ZM18 33.98c-.07-.05-.17-.03-.22.05l-.8 1.4a.16.16 0 0 0 .06.21l2.67 1.27-.25.42a.15.15 0 0 0 .08.22l2.65 1.22c.2-.5.45-.96.77-1.37L18 33.98Zm-1.96 3.79c.01-.1.1-.15.19-.13l5.82 1.52c-.15.5-.24 1.02-.25 1.56l-2.91-.24c-.1 0-.16-.1-.14-.19l.08-.48-2.94-.28c-.09 0-.15-.09-.14-.18l.28-1.59Zm-.22 3.93c-.1 0-.15.1-.14.19l.29 1.58c0 .1.1.15.19.13l2.85-.75.09.49c0 .1.1.14.19.13l2.81-.78a5.7 5.7 0 0 1-.3-1.54l-5.99.55h.01Zm.93 4.17a.16.16 0 0 1 .07-.21l5.43-2.58c.2.48.48.94.81 1.35l-2.38 1.7a.15.15 0 0 1-.22-.05l-.25-.44-2.43 1.68c-.07.05-.18.03-.22-.05l-.81-1.4Zm6.59-1.13-4.23 4.28a.15.15 0 0 0 .01.23l1.24 1.04c.07.06.17.04.22-.03l1.71-2.4.38.32c.08.05.18.04.23-.04l1.66-2.4a5.91 5.91 0 0 1-1.21-1h-.01Zm-.84 6.88a.15.15 0 0 1-.08-.21l2.5-5.48c.46.24.96.42 1.48.52l-.73 2.82a.16.16 0 0 1-.2.1l-.47-.16-.79 2.85c-.02.08-.11.13-.2.1l-1.51-.55Zm4.32-5.1-.49 6c0 .09.07.17.15.17h1.62c.09 0 .16-.08.15-.17l-.24-2.94h.5c.08 0 .16-.08.15-.17l-.28-2.91a5.4 5.4 0 0 1-1.56.02Zm5.8-16.24a.15.15 0 0 0-.08-.21l-1.52-.56c-.08-.03-.18.02-.2.1l-.78 2.86-.47-.17c-.09-.04-.18.02-.2.1l-.74 2.83c.52.1 1.02.28 1.48.51l2.51-5.46Zm3.3 2.38-4.23 4.29a5.74 5.74 0 0 0-1.21-1l1.65-2.4c.06-.08.16-.1.23-.04l.39.33 1.7-2.41a.15.15 0 0 1 .23-.03l1.24 1.03c.07.06.07.17 0 .23Zm2.3 3.37a.15.15 0 0 0 .06-.22l-.81-1.39a.16.16 0 0 0-.22-.05l-2.43 1.68-.25-.43c-.05-.08-.15-.1-.23-.05l-2.38 1.7c.33.4.6.86.81 1.35l5.44-2.58Zm.85 2.19.27 1.58c.02.1-.04.17-.13.19l-6 .55a5.65 5.65 0 0 0-.3-1.53l2.82-.78c.09-.03.18.03.2.12l.08.5 2.85-.75c.09-.02.18.03.2.12Zm-.27 5.82c.08.02.18-.04.19-.13l.27-1.58a.16.16 0 0 0-.13-.19l-2.94-.27.08-.49a.16.16 0 0 0-.14-.18l-2.91-.24c-.01.54-.1 1.06-.25 1.55l5.82 1.52Zm-1.55 3.62a.16.16 0 0 1-.23.05l-4.95-3.42c.31-.42.57-.88.76-1.37l2.66 1.22c.08.04.12.13.07.21l-.25.43L38 46.04c.08.04.11.14.07.22l-.8 1.4Zm-6.63-2.02 3.48 4.9c.05.08.16.09.22.03l1.23-1.03a.16.16 0 0 0 .02-.23l-2.07-2.1.38-.32c.07-.06.07-.16 0-.23l-2.08-2.05c-.35.4-.74.74-1.19 1.03h.01Zm-.03 6.68c-.09.03-.18-.02-.2-.1l-1.6-5.8c.52-.13 1.02-.32 1.47-.57l1.26 2.64c.04.09 0 .19-.09.21l-.47.17 1.23 2.69c.04.08 0 .17-.08.2l-1.52.56Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path clipRule="evenodd" d="M30.44 195.1a5.22 5.22 0 0 0-4.25 3.43c-.13.38-.17.67-.2 1.58-.03 1.27.06 1.8.41 2.5.75 1.5 1.93 2.17 5.43 3.15 1.63.45 2.46.88 2.74 1.41.1.19.12.38.1.76-.01.43-.05.55-.22.78-.42.55-1.09.8-2.17.78-.77 0-1.68-.18-2.3-.45-.5-.21-1.45-.8-2.05-1.25l-.5-.4-1.02 1.3c-.56.71-1.03 1.34-1.05 1.39-.08.2 1.61 1.43 2.6 1.88.74.33 1.76.65 2.59.79.97.17 2.61.17 3.38 0 2.8-.6 4.36-2.48 4.36-5.23 0-1.74-.58-2.95-1.83-3.84-.86-.6-1.65-.93-3.85-1.58-1.72-.51-2.23-.71-2.58-1.01-.36-.3-.48-.59-.48-1.13 0-.4.02-.52.19-.77.54-.81 1.94-1.02 3.47-.5.73.23 1.34.54 2.13 1.06.4.27.56.33.62.27a60 60 0 0 0 1.81-2.83c-.66-.57-1.9-1.3-2.8-1.62a10.07 10.07 0 0 0-4.53-.47Zm16.74-.03c-3.75.5-6.58 3.35-7.27 7.34-.12.69-.14 2.32-.03 3.07a8.7 8.7 0 0 0 5.1 6.88c1.03.43 1.79.58 3.07.6.63.02 1.37 0 1.65-.04a7.2 7.2 0 0 0 2.72-.98l.19-.13-.94-1.45-.95-1.45-.26.13c-.71.36-1.98.5-2.93.34a4.02 4.02 0 0 1-2.34-1.28 3.95 3.95 0 0 1-.95-1.3 7.22 7.22 0 0 1-.66-2.37c-.05-.57.07-1.67.27-2.3a5.04 5.04 0 0 1 3.34-3.43 5.23 5.23 0 0 1 3.14.27.9.9 0 0 0 .38.12c.05-.01.5-.65 1-1.42l.91-1.4-.16-.17c-.2-.22-.97-.61-1.5-.77-.94-.29-2.67-.4-3.78-.26Zm7.83 8.91.02 8.98.94.03c1.56.03 2.16-.23 2.62-1.16.19-.37.22-.52.22-.99 0-.3-.04-.74-.08-.97-.07-.41-.07-.44.1-.58.38-.33.43-.6.15-.88-.1-.1-.16-.2-.11-.22.04-.01.2-.12.37-.23.35-.26.36-.4.1-1.02-.3-.74-.13-1.14.64-1.5.45-.21.71-.56.75-1 .04-.37.06-.34-1.3-2.22-1.03-1.42-1.07-1.55-.65-2.36.23-.46.25-.54.22-.94-.02-.25-.22-.94-.47-1.68a6.34 6.34 0 0 0-.92-2l-.18-.24H55l.02 8.98Zm7.83.02v9h3.6v-5.88c0-4.96.02-5.87.1-5.78.05.06.85 1.32 1.77 2.8 2.53 4.07 2.69 4.32 2.77 4.32.04 0 .37-.48.73-1.06l2.28-3.68 1.64-2.63V213h3.6v-18h-3.92l-1.73 2.93a97.6 97.6 0 0 1-2.56 4.3c-.07.07.3.7-3.27-5.41L66.78 195h-3.94v9Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path d="m41.38 128.89 6.32-8.38v-1.1h-9.41v2.04h5.83l-6.45 8.5v.97h10v-2.03h-6.29ZM57.49 130.92h2.65v-11.5h-2.65v6.61c0 .92-.25 1.67-.76 2.24-.5.57-1.15.85-1.94.85-1.62 0-2.43-1.03-2.43-3.1v-6.6h-2.65v6.87c0 3.27 1.38 4.9 4.15 4.9 1.62 0 2.81-.7 3.58-2.1h.05v1.83ZM69 121.53c.6 0 1.06.12 1.38.37v-2.47a2.26 2.26 0 0 0-1.1-.22c-.66 0-1.26.23-1.8.68a4 4 0 0 0-1.19 1.9h-.04v-2.37H63.6v11.5h2.65v-5.5c0-1.2.26-2.15.79-2.85a2.38 2.38 0 0 1 1.96-1.04Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path clipRule="evenodd" d="M37.1 130.92h-2.98l-1.48-4.1H26.2l-1.42 4.1h-2.97l6.14-16.1H31l6.09 16.1Zm-7.45-12.7 2.27 6.42h-5.01l2.25-6.42c.08-.25.16-.59.23-1.02h.04c.08.47.15.8.22 1.02ZM82.18 125.88h-7.97a3.28 3.28 0 0 0 1 2.46c.64.57 1.51.86 2.62.86 1.25 0 2.4-.37 3.44-1.1v2.1a7.96 7.96 0 0 1-4.23.99 5.28 5.28 0 0 1-4.05-1.57c-.97-1.04-1.46-2.51-1.46-4.4 0-1.8.54-3.26 1.61-4.38a5.33 5.33 0 0 1 4.02-1.7c1.6 0 2.84.51 3.71 1.52.88 1.01 1.32 2.42 1.32 4.22v1Zm-3.23-4.03c.44.52.66 1.25.68 2.18H74.2c.12-.88.45-1.6.98-2.14a2.6 2.6 0 0 1 1.93-.82c.78 0 1.39.26 1.83.78Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path d="M150.77 42.36a6.2 6.2 0 0 1-6.3 6.27 6.2 6.2 0 0 1-6.3-6.27 6.19 6.19 0 0 1 6.3-6.28c3.47 0 6.3 2.64 6.3 6.28Zm-2.76 0c0-2.26-1.64-3.8-3.54-3.8-1.9 0-3.54 1.54-3.54 3.8 0 2.23 1.64 3.8 3.54 3.8 1.9 0 3.54-1.57 3.54-3.8ZM164.36 42.36a6.2 6.2 0 0 1-6.3 6.27 6.2 6.2 0 0 1-6.3-6.27 6.19 6.19 0 0 1 6.3-6.28c3.47 0 6.3 2.64 6.3 6.28Zm-2.76 0c0-2.26-1.64-3.8-3.54-3.8-1.9 0-3.54 1.54-3.54 3.8 0 2.23 1.63 3.8 3.54 3.8 1.9 0 3.54-1.57 3.54-3.8ZM177.38 36.46v11.27c0 4.64-2.74 6.53-5.97 6.53a5.98 5.98 0 0 1-5.56-3.7l2.4-1a3.47 3.47 0 0 0 3.16 2.23c2.07 0 3.35-1.28 3.35-3.68v-.9h-.1a4.28 4.28 0 0 1-3.3 1.42 6.22 6.22 0 0 1-6.02-6.25c0-3.55 2.88-6.3 6.02-6.3 1.5 0 2.68.66 3.3 1.4h.1v-1.02h2.62Zm-2.42 5.92c0-2.21-1.48-3.83-3.36-3.83-1.9 0-3.5 1.62-3.5 3.83 0 2.19 1.6 3.78 3.5 3.78 1.88 0 3.36-1.6 3.36-3.78ZM181.7 29.85v18.4H179v-18.4h2.7ZM192.18 44.42l2.13 1.43a6.25 6.25 0 0 1-5.23 2.78 6.14 6.14 0 0 1-6.23-6.28c0-3.73 2.69-6.28 5.93-6.28 3.25 0 4.85 2.6 5.37 4l.28.71-8.39 3.48a3.2 3.2 0 0 0 3.04 1.9c1.4 0 2.38-.69 3.1-1.74Zm-6.6-2.26 5.62-2.33c-.31-.78-1.24-1.33-2.33-1.33a3.44 3.44 0 0 0-3.28 3.66ZM127.99 40.72v-2.66h8.98c.09.46.13 1.01.13 1.6 0 2-.55 4.48-2.3 6.24a8.92 8.92 0 0 1-6.8 2.73 9.89 9.89 0 0 1-9.9-9.75 9.89 9.89 0 0 1 9.9-9.75 9.3 9.3 0 0 1 6.67 2.69l-1.88 1.88a7 7 0 0 0-11.8 5.18 7 7 0 0 0 7 7.09c2.55 0 4-1.02 4.92-1.95a5.53 5.53 0 0 0 1.45-3.3h-6.37Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path clipRule="evenodd" d="M156 222a18 18 0 1 0 0-36 18 18 0 0 0 0 36Zm-1.08-18.4v-7.33h-1.83l.01 6.44v1.22c.01 4.82.01 5.41.17 5.96l.08.24.05.16c1.58 4.94 8.75 5.38 11.1.68 2.21-4.41-1.07-9.51-5.87-9.13a5.04 5.04 0 0 0-3.36 1.44l-.35.32Zm3.68 0c-4.3.44-5.33 6.65-1.4 8.55a4.22 4.22 0 0 0 6-2.74c.81-3.24-1.48-6.14-4.6-5.81Zm-6.77-.54c-1.22-4.16-1.78-5.08-3.9-6.42-.57-.36-.6-.37-.4-.14.83 1 1.44 1.87 2.07 2.96a63.8 63.8 0 0 1 1.62 3.22c0 .02-.36-.35-.8-.8a10.56 10.56 0 0 0-4.76-3.24 9.07 9.07 0 0 0-2.51-.66c-.03 0 .22.26.56.56.94.85 1.77 1.71 2.36 2.44 1.67 2.08 2.57 2.62 5.11 3.05.57.1.99.15.98.13l-.33-1.1Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                        <path d="M142.37 117.24c0-2.86-1.45-5.2-4.19-7.17h6.34a8.94 8.94 0 0 1 0 14.35c2.06.85 3.22 2.91 3.22 5.86v5.66h-5.71v-5.66c0-2.83-1.35-4.8-3.81-5.87 2.7-2 4.15-4.34 4.15-7.17Zm12.41 0c0-2.86-1.44-5.2-4.18-7.17h6.33a8.94 8.94 0 0 1 0 14.35c2.06.85 3.23 2.91 3.23 5.86v5.66h-5.72v-5.66c0-2.83-1.35-4.8-3.8-5.87 2.7-2 4.14-4.34 4.14-7.17Zm12.42 0c0-2.86-1.44-5.2-4.18-7.17h6.33a8.94 8.94 0 0 1 0 14.35c2.06.85 3.23 2.91 3.23 5.86v5.66h-5.72v-5.66c0-2.83-1.35-4.8-3.8-5.87 2.7-2 4.14-4.34 4.14-7.17Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                      </g>
                      <path d="M103.5 0v246M0 82.5h208M0 164.5h208" stroke="var(--gray-a5)" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                    </svg>
                  </Diagram.PanelContent>
                  <Diagram.PanelFade data-sentry-element="Diagram.PanelFade" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Provides the directory data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">WorkOS directory</Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Box px="3" py="2" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Box style={{
                      fontFamily: 'var(--code-font-family)',
                      fontSize: 11,
                      lineHeight: 16 / 11,
                      whiteSpace: 'pre'
                    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span className="token keyword">interface</span>{' '}
                          <span className="token class-name">Directory</span>{' '}
                          {'{'}
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            object:{' '}
                          </span>
                          <span className="token string">"directory"</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            id
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            domain
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            external_key
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            name
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            organization_id
                          </span>
                          <span className="token operator">?:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            state
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            type
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            created_at
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            updated_at
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">{'}'}</Box>
                      </Box>
                    </Box>
                  </Diagram.PanelContent>
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Normalizes directory data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <DiagramPanelYourApp data-sentry-element="DiagramPanelYourApp" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Interfaces with WorkOS</Diagram.Caption>
              </Flex>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const Group = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="Group" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="A diagram showing that directory provider groups relay the directory group data to WorkOS, then WorkOS normalizes the data, and then your app interfaces with WorkOS, receiving and pushing updates" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 784 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="320" width="784" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    Directory provider groups
                  </Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Grid columns="2" gap="2" p="2" data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Flex direction="column" gap="2" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--blue-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--blue-9)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(12).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--blue-a10)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Accounting
                          </Text>
                        </Flex>

                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--yellow-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--yellow-11)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(12).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.7" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--yellow-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Sales
                          </Text>
                        </Flex>
                      </Flex>

                      <Flex align="center" direction="column" pt="2" px="2" style={{
                      borderRadius: 'var(--radius-4)',
                      backgroundColor: 'var(--green-a3)'
                    }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Grid columns="4" style={{
                        rowGap: 4.5,
                        columnGap: 4,
                        color: 'var(--green-9)'
                      }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          {Array(32).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
                        </Grid>
                        <Text align="center" as="div" style={{
                        color: 'var(--green-a10)',
                        fontSize: 11,
                        lineHeight: 24 / 11
                      }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          Engineering
                        </Text>
                      </Flex>
                    </Grid>
                  </Diagram.PanelContent>
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Provides the user group data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    WorkOS directory group
                  </Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Flex direction="column" height="100%" justify="center" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Box px="3" py="2" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box style={{
                        fontFamily: 'var(--code-font-family)',
                        fontSize: 11,
                        lineHeight: 18 / 11,
                        whiteSpace: 'pre'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span className="token keyword">interface</span>{' '}
                            <span className="token class-name">Group</span>{' '}
                            {'{'}
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              id
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              idp_id
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              directory_id
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              organization_id
                            </span>
                            <span className="token operator">?:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              name
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              created_at
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <span>{'  '}</span>
                            <span className="token literal-property property">
                              updated_at
                            </span>
                            <span className="token operator">:</span>
                            <span> </span>
                            <span className="token keyword">string</span>;
                          </Box>
                          <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">{'}'}</Box>
                        </Box>
                      </Box>
                    </Flex>
                  </Diagram.PanelContent>
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Normalizes user group data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <DiagramPanelYourApp data-sentry-element="DiagramPanelYourApp" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Interfaces with WorkOS</Diagram.Caption>
              </Flex>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const User = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="User" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="A diagram showing that directory provider users relay the user data to WorkOS, then WorkOS normalizes the data, and then your app interfaces with WorkOS, receiving and pushing updates" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 784 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="320" width="784" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    Directory provider users
                  </Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Grid columns="5" gap="2" p="2" style={{
                    rowGap: 6,
                    columnGap: 4
                  }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      {Array(32).fill(0).map((_, i) => <Flex key={i} align="center" justify="center">
                            <UserCircledIcon color={i ? 'var(--gray-a7)' : 'currentcolor'} height="32" width="32" />
                          </Flex>)}
                    </Grid>
                  </Diagram.PanelContent>
                  <Diagram.PanelFade data-sentry-element="Diagram.PanelFade" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Provides the user data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    WorkOS directory user
                  </Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Box px="3" py="2" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Box style={{
                      fontFamily: 'var(--code-font-family)',
                      fontSize: 11,
                      lineHeight: 18 / 11,
                      whiteSpace: 'pre'
                    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span className="token keyword">interface</span>{' '}
                          <span className="token class-name">User</span> {'{'}
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            id
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            idp_id
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            directory_id
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            first_name
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            last_name
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            email
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            groups
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token class-name">Group</span>
                          <span className="token operator">[]</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <span>{'  '}</span>
                          <span className="token literal-property property">
                            state
                          </span>
                          <span className="token operator">:</span>
                          <span> </span>
                          <span className="token keyword">string</span>;
                        </Box>
                        <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">{'}'}</Box>
                      </Box>
                    </Box>
                  </Diagram.PanelContent>
                  <Diagram.PanelFade data-sentry-element="Diagram.PanelFade" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Normalizes user data</Diagram.Caption>
              </Flex>

              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />

              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <DiagramPanelYourApp data-sentry-element="DiagramPanelYourApp" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Interfaces with WorkOS</Diagram.Caption>
              </Flex>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const Roles = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="Roles" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="A diagram showing how you add roles to user profile data in WorkOS, which in turn is used by your app for roles-based business logic." data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 784 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="320" width="784" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" justify="between" mx="127px" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <RolesUsers data-sentry-element="RolesUsers" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
              <RolesAppCode data-sentry-element="RolesAppCode" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const RoleMapping = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="RoleMapping" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="A diagram showing how directory provider groups of your customer’s team are re-mapped to the roles that you defined, which in turn are used by your app for roles-based business logic." data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 784 320" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="320" width="784" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" justify="between" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    Directory provider groups
                  </Diagram.PanelHeader>
                  <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <Grid columns="2" gap="2" p="2" data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Flex direction="column" gap="2" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--purple-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--purple-a10)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(4).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--purple-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Management
                          </Text>
                        </Flex>

                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--green-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--green-a10)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(20).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.7" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--green-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Client service
                          </Text>
                        </Flex>

                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--green-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--green-a10)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(20).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.7" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--green-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Client service
                          </Text>
                        </Flex>
                      </Flex>

                      <Flex direction="column" gap="2" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--yellow-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 5,
                          columnGap: 4,
                          color: 'var(--yellow-a11)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(8).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--yellow-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Design
                          </Text>
                        </Flex>

                        <Flex align="center" direction="column" pt="2" px="2" style={{
                        borderRadius: 'var(--radius-4)',
                        backgroundColor: 'var(--blue-a3)'
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Grid columns="4" style={{
                          rowGap: 6,
                          columnGap: 4,
                          color: 'var(--blue-a10)'
                        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            {Array(16).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.7" />)}
                          </Grid>
                          <Text align="center" as="div" style={{
                          color: 'var(--blue-a11)',
                          fontSize: 11,
                          lineHeight: 24 / 11
                        }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            Engineering
                          </Text>
                        </Flex>
                      </Flex>
                    </Grid>
                  </Diagram.PanelContent>
                </Diagram.Panel>
                <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Map to your role definitions</Diagram.Caption>
              </Flex>
              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
              <RolesUsers data-sentry-element="RolesUsers" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
              <DiagramArrows data-sentry-element="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
              <RolesAppCode data-sentry-element="RolesAppCode" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const RolesUsers = () => <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-component="RolesUsers" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">WorkOS users</Diagram.PanelHeader>
      <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <Grid columns="2" gap="2" p="2" data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Flex direction="column" gap="2" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" direction="column" pt="2" px="2" style={{
            borderRadius: 'var(--radius-4)',
            boxShadow: 'inset 0 0 0 1px var(--gray-a4)',
            backgroundColor: 'var(--gray-a2)'
          }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Grid columns="4" style={{
              rowGap: 6,
              columnGap: 4,
              color: 'var(--gray-a10)'
            }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                {Array(4).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
              </Grid>
              <Text align="center" as="div" style={{
              fontSize: 11,
              lineHeight: 24 / 11
            }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                Admin
              </Text>
            </Flex>

            <Flex align="center" direction="column" pt="2" px="2" style={{
            borderRadius: 'var(--radius-4)',
            boxShadow: 'inset 0 0 0 1px var(--gray-a4)',
            backgroundColor: 'var(--gray-a2)'
          }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Grid columns="4" style={{
              rowGap: 6,
              columnGap: 4,
              color: 'var(--gray-a10)'
            }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                {Array(20).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
              </Grid>
              <Text align="center" as="div" style={{
              fontSize: 11,
              lineHeight: 24 / 11
            }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                Viewer
              </Text>
            </Flex>
          </Flex>

          <Flex align="center" direction="column" pt="2" px="2" style={{
          borderRadius: 'var(--radius-4)',
          boxShadow: 'inset 0 0 0 1px var(--gray-a4)',
          backgroundColor: 'var(--gray-a2)'
        }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Grid columns="4" style={{
            rowGap: 4.5,
            columnGap: 4,
            color: 'var(--gray-a10)'
          }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              {Array(32).fill(0).map((_, i) => <UserCircledIcon key={i} fillOpacity="0.8" />)}
            </Grid>
            <Text align="center" as="div" style={{
            fontSize: 11,
            lineHeight: 24 / 11
          }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              Editor
            </Text>
          </Flex>
        </Grid>
      </Diagram.PanelContent>
    </Diagram.Panel>
    <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Include role data</Diagram.Caption>
  </Flex>;
const RolesAppCode = () => <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-component="RolesAppCode" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Your app</Diagram.PanelHeader>
      <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <Flex direction="column" height="100%" justify="center" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Box px="3" py="2" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Box style={{
            fontFamily: 'var(--code-font-family)',
            fontSize: 11,
            lineHeight: 18 / 11,
            whiteSpace: 'pre'
          }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token comment">
                  {'// Get available features'}
                </span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token keyword">if</span>{' '}
                <span className="token punctuation">(</span>
                <span className="token">role</span>{' '}
                <span className="token operator">===</span>{' '}
                <span className="token string">'admin'</span>
                <span className="token punctuation">)</span>{' '}
                <span className="token punctuation">{'{'}</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                {'  '}
                <span className="token keyword">return</span>{' '}
                <span className="token punctuation">[</span>
                <span className="token">...AllFeatures</span>
                <span className="token punctuation">]</span>
                <span className="token punctuation">;</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token punctuation">{'}'}</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token keyword">if</span>{' '}
                <span className="token punctuation">(</span>
                <span className="token">role</span>{' '}
                <span className="token operator">===</span>{' '}
                <span className="token string">'editor'</span>
                <span className="token punctuation">)</span>{' '}
                <span className="token punctuation">{'{'}</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                {'  '}
                <span className="token keyword">return</span>{' '}
                <span className="token punctuation">[</span>
                <span className="token">Projects</span>
                <span className="token punctuation">,</span>{' '}
                <span className="token">Logs</span>
                <span className="token punctuation">]</span>
                <span className="token punctuation">;</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token punctuation">{'}'}</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token keyword">if</span>{' '}
                <span className="token punctuation">(</span>
                <span className="token">role</span>{' '}
                <span className="token operator">===</span>{' '}
                <span className="token string">'viewer'</span>
                <span className="token punctuation">)</span>{' '}
                <span className="token punctuation">{'{'}</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                {'  '}
                <span className="token keyword">return</span>{' '}
                <span className="token punctuation">[</span>
                <span className="token">Logs</span>
                <span className="token punctuation">]</span>
                <span className="token punctuation">;</span>
              </Box>
              <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <span className="token punctuation">{'}'}</span>
              </Box>
            </Box>
          </Box>
        </Flex>
      </Diagram.PanelContent>
    </Diagram.Panel>
    <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Implements role-based logic</Diagram.Caption>
  </Flex>;
const CustomRoleMapping = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="CustomRoleMapping" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="An example role mapping UI in an app" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 688 424" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="424" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Diagram.Panel height="auto" width="100%" data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  Settings – Role mapping
                </Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Grid p="4" style={{
                  fontSize: 13,
                  gridTemplateColumns: '96px 1fr',
                  gap: 24
                }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <YourAppSidebar data-sentry-element="YourAppSidebar" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                    <Flex direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Box style={{
                      overflow: 'hidden',
                      borderRadius: 8
                    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box style={{
                        backgroundColor: 'var(--gray-a3)',
                        fontWeight: 'bold'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Flex align="center" gap="4" height="32px" px="3" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <Box width="112px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Group</Box>
                            <Box width="56px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Role</Box>
                            <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Description</Box>
                          </Flex>
                        </Box>
                        <Box style={{
                        backgroundColor: 'var(--gray-a2)'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          {[{
                          group: 'Engineering',
                          role: 'Editor',
                          description: 'Can edit documents'
                        }, {
                          group: 'Designers',
                          role: 'Editor',
                          description: 'Can edit documents'
                        }, {
                          group: 'Managers',
                          role: 'Viewer',
                          description: 'Can view documents'
                        }, {
                          group: 'Accounting',
                          role: 'Viewer',
                          description: 'Can view documents'
                        }, {
                          group: 'Sales',
                          role: 'Viewer',
                          description: 'Can view documents'
                        }, {
                          group: 'Ops',
                          role: 'Admin',
                          description: 'Can edit documents and team details'
                        }].map(row => <Flex key={row.group} align="center" gap="4" height="32px" px="3" style={{
                          boxShadow: '0 1px var(--gray-4)'
                        }}>
                              <Box width="80px">{row.group}</Box>
                              <ArrowRightIcon color="var(--gray-a8)" height="16" width="16" />
                              <Box width="56px">{row.role}</Box>
                              <Box style={{
                            color: 'var(--gray-a11)'
                          }}>
                                {row.description}
                              </Box>
                            </Flex>)}
                        </Box>
                      </Box>

                      <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Flex display="inline-flex" style={{
                        backgroundColor: 'var(--gray-a3)',
                        fontWeight: 'bold',
                        borderRadius: 6,
                        padding: 8,
                        gap: 6
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <PlusCircledIcon height="16" width="16" data-sentry-element="PlusCircledIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                          Add mapping
                        </Flex>
                      </Box>
                    </Flex>
                  </Grid>
                </Diagram.PanelContent>
              </Diagram.Panel>
              <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                Example role mapping UI in an app
              </Diagram.Caption>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const CustomRoles = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="CustomRoles" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <AccessibleIcon label="An example custom role management UI in an app" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <svg viewBox="0 0 688 440" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <foreignObject height="440" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
          <Diagram.Root data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
            <Flex align="center" direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
              <Diagram.Panel height="auto" width="100%" data-sentry-element="Diagram.Panel" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Settings – Roles</Diagram.PanelHeader>
                <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                  <Grid p="4" style={{
                  fontSize: 13,
                  gridTemplateColumns: '96px 1fr',
                  gap: 24
                }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                    <YourAppSidebar data-sentry-element="YourAppSidebar" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                    <Flex direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                      <Box style={{
                      overflow: 'hidden',
                      borderRadius: 8
                    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box style={{
                        backgroundColor: 'var(--gray-a3)',
                        fontWeight: 'bold'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Flex align="center" gap="4" height="32px" px="3" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <Box width="88px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Default roles</Box>
                            <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Description</Box>
                          </Flex>
                        </Box>
                        <Box style={{
                        backgroundColor: 'var(--gray-a2)'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          {[{
                          role: 'Admin',
                          description: 'Can edit documents and team details'
                        }, {
                          role: 'Editor',
                          description: 'Can view and edit documents'
                        }, {
                          role: 'Viewer',
                          description: 'Can view documents'
                        }].map(row => <Flex key={row.role} align="center" gap="4" height="32px" px="3" style={{
                          boxShadow: '0 1px var(--gray-4)'
                        }}>
                              <Box width="88px">{row.role}</Box>
                              <Box style={{
                            color: 'var(--gray-a11)'
                          }}>
                                {row.description}
                              </Box>
                            </Flex>)}
                        </Box>
                      </Box>

                      <Box style={{
                      overflow: 'hidden',
                      borderRadius: 8
                    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Box style={{
                        backgroundColor: 'var(--gray-a3)',
                        fontWeight: 'bold'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <Flex align="center" gap="4" height="32px" px="3" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                            <Box width="88px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Custom roles</Box>
                            <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Description</Box>
                          </Flex>
                        </Box>
                        <Box style={{
                        backgroundColor: 'var(--gray-a2)'
                      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          {[{
                          role: 'Super admin',
                          description: 'Can edit documents, team details, and billing'
                        }, {
                          role: 'Manager',
                          description: 'Can view documents and edit team details'
                        }].map(row => <Flex key={row.role} align="center" gap="4" height="32px" px="3" style={{
                          boxShadow: '0 1px var(--gray-4)'
                        }}>
                              <Box width="88px">{row.role}</Box>
                              <Box style={{
                            color: 'var(--gray-a11)'
                          }}>
                                {row.description}
                              </Box>
                            </Flex>)}
                        </Box>
                      </Box>

                      <Box data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                        <Flex display="inline-flex" style={{
                        backgroundColor: 'var(--gray-a3)',
                        fontWeight: 'bold',
                        borderRadius: 6,
                        padding: 8,
                        gap: 6
                      }} data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                          <PlusCircledIcon height="16" width="16" data-sentry-element="PlusCircledIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
                          Add role
                        </Flex>
                      </Box>
                    </Flex>
                  </Grid>
                </Diagram.PanelContent>
              </Diagram.Panel>
              <Diagram.Caption data-sentry-element="Diagram.Caption" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
                Example custom role management UI in an app
              </Diagram.Caption>
            </Flex>
          </Diagram.Root>
        </foreignObject>
      </svg>
    </AccessibleIcon>
  </MdxImage>;
const YourAppSidebar = () => <Box data-sentry-element="Box" data-sentry-component="YourAppSidebar" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <Box style={{
    width: 48,
    height: 48,
    marginBottom: 24,
    borderRadius: 12,
    backgroundColor: 'var(--gray-a3)'
  }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
    <Flex direction="column" gap="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      {Array(3).fill(0).map((_, i) => <Flex key={i} gap="2">
            <Box style={{
        width: 16,
        height: 16,
        borderRadius: 16,
        backgroundColor: 'var(--gray-a3)'
      }} />
            <Box style={{
        flexGrow: 1,
        height: 16,
        borderRadius: 6,
        backgroundColor: 'var(--gray-a3)'
      }} />
          </Flex>)}
      <Flex gap="2" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <Box style={{
        width: 16,
        height: 16,
        borderRadius: 16,
        backgroundColor: 'var(--gray-a3)'
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
        <Box style={{
        width: 48,
        height: 16,
        borderRadius: 6,
        backgroundColor: 'var(--gray-a3)'
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
      </Flex>
    </Flex>
  </Box>;
const DiagramArrows = () => <Flex direction="column" gap="5" style={{
  marginBottom: 20
}} width="32px" data-sentry-element="Flex" data-sentry-component="DiagramArrows" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
    <Diagram.Arrow direction="left" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
  </Flex>;
const DiagramPanelYourApp = () => <Diagram.Panel height={240} width={208} data-sentry-element="Diagram.Panel" data-sentry-component="DiagramPanelYourApp" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <Diagram.PanelHeader data-sentry-element="Diagram.PanelHeader" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">Your app</Diagram.PanelHeader>
    <Diagram.PanelContent data-sentry-element="Diagram.PanelContent" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
      <Flex align="center" height="100%" justify="center" pb="4" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
        <Diagram.YourAppIcon data-sentry-element="Diagram.YourAppIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
        <Box style={{
        width: 128,
        height: 128,
        marginLeft: -128,
        background: 'radial-gradient(transparent, var(--color-panel-solid) 80%, var(--color-panel-solid))'
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
      </Flex>
    </Diagram.PanelContent>
  </Diagram.Panel>;
const UserCircledIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => <svg fill="currentcolor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="UserCircledIcon" data-sentry-source-file="directory-sync-diagrams-foundations.tsx">
    <path d="M8 1.5C4.41797 1.5 1.5 4.41797 1.5 8C1.5 11.582 4.41797 14.5 8 14.5C11.582 14.5 14.5 11.582 14.5 8C14.5 4.41797 11.582 1.5 8 1.5ZM8 2.5C11.043 2.5 13.5 4.95703 13.5 8C13.5 9.33984 13.0234 10.5625 12.2344 11.5156C11.8047 10.2969 10.875 9.31641 9.6875 8.83203C10.1836 8.375 10.5 7.72266 10.5 7C10.5 5.625 9.375 4.5 8 4.5C6.625 4.5 5.5 5.625 5.5 7C5.5 7.72266 5.81641 8.375 6.3125 8.83203C5.125 9.31641 4.19922 10.2969 3.76953 11.5156C2.97656 10.5625 2.5 9.33984 2.5 8C2.5 4.95703 4.95703 2.5 8 2.5ZM8 5.5C8.83594 5.5 9.5 6.16406 9.5 7C9.5 7.83594 8.83594 8.5 8 8.5C7.16406 8.5 6.5 7.83594 6.5 7C6.5 6.16406 7.16406 5.5 8 5.5ZM8 9.5C9.69922 9.5 11.0938 10.707 11.418 12.3086C10.4766 13.0547 9.29297 13.5 8 13.5C6.70703 13.5 5.52344 13.0547 4.58594 12.3086C4.90625 10.707 6.30078 9.5 8 9.5Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-foundations.tsx" />
  </svg>;
export const DirectorySyncDiagramsFoundations = {
  Directory,
  Group,
  User,
  RoleMapping,
  Roles,
  CustomRoleMapping,
  CustomRoles
};